import { IconButton as MUIIconButton, IconButtonProps } from '@mui/material';

export { type IconButtonProps } from '@mui/material';

export function IconButton(props: IconButtonProps) {
  return <MUIIconButton {...props} />;
}
